module.exports = __webpack_public_path__ + "static/media/history-cold-war.be6d5892.vtt";